import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getRate = () => http({
    url: ENDPOINTS.enumeration,
    method: 'get',
    params: {
        enumerationType: "Rate",
        
    },
}).then((res) => {
    return res.data
}).catch((err) => {
    //  
    return Promise.reject(err);
});
export const sendDeliverForm = (data ,method,referenceId  ) => http({
    url: ENDPOINTS.cartable.jobDelivery.load,
    method: method,
    params:{
        referenceId:referenceId ,
    },
    data:data
}).then((res) => {
    return res.data
}).catch((err) => {
    //  
    return Promise.reject(err);
});
export const getDeliverForm = (Id , referenceId ) => http({
    url: ENDPOINTS.cartable.jobDelivery.load,
    headers: { "Accept-Language": "en" },

    method: "get",
    params:{
        referenceId:referenceId ,
        jobId : Id
    }
}).then((res) => {
    return res.data
}).catch((err) => {
    //  
    return Promise.reject(err);
});
